import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './index.css';
import AuthFlow from './AuthFlow';
import Landing from './Landing';
import Results from './Results';
import Dev from './Dev'
import ConfettiContainer from './ConfettiContainer';
import {ThemeProvider} from './ThemeContext';

<link href="https://fonts.googleapis.com/css2?family=Nunito+Sans:wght@400;500;600;700&display=swap" rel="stylesheet"></link>

  ReactDOM.createRoot(document.getElementById('root')).render(
    <>
    <ThemeProvider>
    <ConfettiContainer/>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing/>}></Route> 
        <Route path="/AuthFlow" element={<AuthFlow/>} />
        <Route path="/results" element={<Results/>} />
        <Route path="/dev" element={<Dev/>} />
      </Routes>
    </BrowserRouter>
    </ThemeProvider>
    </>
  );
